<template>
  <div class="common-card bad-debt-list-wrapper">
    <!-- <modal-filter
      :filter_project_id.sync="filter_project_id"
      :filter_approval_status_id.sync="filter_approval_status_id"
      :filter_payment_method_id.sync="filter_payment_method_id"
      :projectOptions="projectOptions"
      :approvalStatusOptions="approvalStatusOptions"
      :paymentMethodStatusOptions="paymentMethodStatusOptions"
      @refetch-data="refetchData"
    /> -->
    <b-card class="top mb-0">
      <div class="d-flex flex-wrap align-items-center justify-content-between">
        <div class="d-flex mb-1 mb-sm-0 align-items-center">
          <h4 class="font-weight-bolder ml-1 text-nowrap mb-0">
            <font-awesome-icon class="mr-50" icon="fa-solid fa-file-lines" />
            壞賬記錄
          </h4>
          <div class="d-flex ml-3 align-items-center">
            <label>顯示</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>條目</label>
          </div>
        </div>
        <div class="d-flex flex-wrap mobile-w100 mt-1 mt-lg-0">
          <b-form-input
            v-model="searchQuery"
            class="search-form mb-1 mb-sm-0 mr-sm-1"
            placeholder="搜尋壞賬"
          />
          <!-- <b-button
            variant="primary"
            class="mobile-w100 mb-1 mb-sm-0 mr-sm-1"
            @click="$bvModal.show('modal-filter')"
            ><feather-icon
              class="mr-1"
              icon="filterIcon"
              size="18"
            ></feather-icon
            >篩選</b-button
          > -->
          <b-button class="mobile-w100" :to="{ name: 'bad-debt-create' }" v-if="ability.can('create', 'bad_debts')">
            <feather-icon class="mr-1" icon="plusIcon" size="18"></feather-icon
            >新增記錄</b-button
          >
        </div>
      </div>
    </b-card>

    <b-card no-body class="card-statistics bottom">
      <b-card-body class="p-2">
        <b-table
          ref="refBadDebtListTable"
          class="position-relative"
          :items="fetchBadDebts"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <template #cell(project_id)="data">
            {{ getProject(data.item.project_id).project_number }}
          </template>
          <template #cell(project_name)="data">
            {{ getProject(data.item.project_id).project_name }}
          </template>
          <template #cell(address)="data">
            {{ getProject(data.item.project_id).address }}
          </template>

          <template #cell(invoice_id)="data">
            {{ getInvoice(data.item.invoice_id).invoice_number }}
          </template>

          <template #cell(customer_id)="data">
            {{ getCustomer(data.item.customer_id).user_number }}
          </template>

          <template #cell(name_cn)="data">
            {{ getCustomer(data.item.customer_id).name_cn }}
          </template>
          <template #cell(name_en)="data">
            {{ getCustomer(data.item.customer_id).name }}
          </template>
          <template #cell(mobile)="data">
            {{ getCustomer(data.item.customer_id).phone }}
          </template>
          <template #cell(email)="data">
            {{ getCustomer(data.item.customer_id).email }}
          </template>
          <template #cell(amount)="data">
            ${{ Number(data.item.amount) }}
          </template>

          <template #cell(created_at)="data">
            {{ getDateTime(data.item.created_at) }}
          </template>

          <template #cell(actions)="data">
            <b-dropdown
              :class="`action-trigger-btn ${
                badDebtsList.length <= 3 ? 'hor' : 'ver'
              }`"
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="EyeIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>

              <!-- <b-dropdown-item
                v-if="ability.can('read', 'bad-debt')"
                :to="{
                  name: 'bad-debt-view',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="FileTextIcon" />
                <span class="align-middle ml-50">詳細資料</span>
              </b-dropdown-item> -->

              <b-dropdown-item
                v-if="ability.can('update', 'bad_debts')"
                :to="{
                  name: 'bad-debt-edit',
                  params: { id: data.item.id },
                }"
              >
                <feather-icon icon="EditIcon" />
                <span class="align-middle ml-50">修改資料</span>
              </b-dropdown-item>

              <b-dropdown-item
                v-if="ability.can('delete', 'bad_debts')"
                @click="removeItem(data.item.id)"
              >
                <feather-icon icon="Trash2Icon" />
                <span class="align-middle ml-50">刪除記錄</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }}個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRow"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
    
<script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import useBadDebtsList from "./useBadDebtsList";
import badDebtStoreModule from "../badDebtStoreModule";
import ModalFilter from "../modal/ModalFilter.vue";

export default {
  components: {
    ModalFilter,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {};
  },
  methods: {
    removeItem(id) {
      // check number of record
      this.$swal({
        title: "你確定嗎?",
        text: "您的決定是最終決定，您將無法取回這記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("bad-debt/deleteBadDebt", { id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.refetchData();
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = "bad-debt";

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME))
      store.registerModule(USER_APP_STORE_MODULE_NAME, badDebtStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME))
        store.unregisterModule(USER_APP_STORE_MODULE_NAME);
    });

    const getProject = (id) => {
      if (!id || !projectOptions.value?.length) return {};
      return projectOptions.value.find(ele => ele.id === id) || {};
    };

    const getCustomer = (id) => {
      if (!id || !customerOptions.value?.length) return {};
      return customerOptions.value.find(ele => ele.id === id) || {};
    };

    const getInvoice = (id) => {
      if (!id || !invoiceOptions.value?.length) return {};
      return invoiceOptions.value.find(ele => ele.id === id) || {};
    };

    const {
      fetchBadDebts,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      badDebtsList,
      refBadDebtListTable,
      refetchData,
      ability,
      refetchOption,
      filter_project_id,
      filter_customer_id,
      filter_invoice_id,
      projectOptions,
      customerOptions,
      invoiceOptions,
    } = useBadDebtsList();

    return {
      fetchBadDebts,
      tableColumns,
      perPage,
      currentPage,
      totalRow,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      badDebtsList,
      refBadDebtListTable,
      refetchData,
      ability,
      refetchOption,
      filter_project_id,
      filter_customer_id,
      filter_invoice_id,
      projectOptions,
      customerOptions,
      invoiceOptions,
      getProject,
      getCustomer,
      getInvoice,
    };
  },
};
</script>
    
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

// @media screen and (max-width: 768px) {

// }
// @media screen and (max-width: 575px) {

// }
</style>
    
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
@media (min-width: 540px) {
  .bad-debt-list-wrapper {
    .sticky-column {
     
    }
  }
}
</style>
    